import React from 'react';
import AudioMessage from './AudioMessage';

function AudioSection({
    file,
    message,
    showTitle = true,
    showTranscriptionIntro = false,
    isUploading = false,
    uploadProgress = 0,
    uploadStatus = 'uploading',
    onCancelUpload
}) {
    let title;
    if (file.displayName) {
        title = file.displayName;
    } else if (file.name) {
        title = file.name;
    } else {
        title = new Date().toISOString();
    }
    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                maxWidth: '100%',
                minWidth: 0
            }}
        >
            <AudioMessage 
                url={file.cdn_url || file.url}
                fallbackUrl={file.cdn_url ? file.url : null}
                title={title}
                showTitle={showTitle}
                fileName={file.name}
                fileSize={file.size}
                initialDuration={file.duration}
                message={message}
                showTranscriptionIntro={showTranscriptionIntro}
                isUploading={isUploading}
                uploadProgress={uploadProgress}
                uploadStatus={uploadStatus}
                onCancelUpload={onCancelUpload}
            />
        </div>
    );
}

export default AudioSection;
